import { ECO_BEAM_PRICING_TIERS } from '../../utils/ecoBeamPricing';
import '../../assets/Helpers.css';

const formatPrice = (price) =>
    price ? price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';

export const EcoBeamPricingTable = ({ compact = false }) => (
    <div className={`eco-beam-pricing${compact ? ' eco-beam-pricing--compact' : ''}`}>
        {!compact && <p className="eco-beam-pricing__label"><strong>Pricing:</strong></p>}
        <table className="eco-beam-pricing__table">
            <thead>
                <tr>
                    <th>Mounts</th>
                    <th>Price per mount</th>
                </tr>
            </thead>
            <tbody>
                {ECO_BEAM_PRICING_TIERS.map(({ minMounts, pricePerMount }) => (
                    <tr key={minMounts}>
                        <td>{minMounts}+</td>
                        <td>${formatPrice(pricePerMount)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);
